var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"animated shake delay-1s"},[_vm._v("404 Not Found")]),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go Back to Top")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }